import { Card, CardContent, Skeleton } from '@heroui/react';

export const DashboardSkeleton = () => {
  return (
    <div className="p-6 space-y-8 animate-pulse">
      <Skeleton className="h-10 w-48 rounded-lg bg-[var(--color-bg-subtle)]" />
      
      {/* Team Management Skeleton */}
      <section className="space-y-4">
        <Skeleton className="h-6 w-40 rounded-lg bg-[var(--color-bg-subtle)]" />
        <Card className="bg-[var(--color-bg-card)] border border-[var(--color-border-default)]">
          <CardContent className="p-4 space-y-3">
            <Skeleton className="h-4 w-full rounded bg-[var(--color-bg-subtle)]" />
            <Skeleton className="h-4 w-2/3 rounded bg-[var(--color-bg-subtle)]" />
          </CardContent>
        </Card>
      </section>

      {/* Your Accounts Skeleton */}
      <section>
        <div className="flex items-center justify-between mb-4">
          <Skeleton className="h-8 w-32 rounded-lg bg-[var(--color-bg-subtle)]" />
          <Skeleton className="h-4 w-16 rounded bg-[var(--color-bg-subtle)]" />
        </div>

        <div className="grid gap-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
          {[1, 2, 3, 4, 5, 6].map((i) => (
            <Card key={i} className="bg-[var(--color-bg-card)] border border-[var(--color-border-default)]">
              <CardContent className="flex items-center gap-4 p-4">
                <Skeleton className="w-12 h-12 rounded-full bg-[var(--color-bg-subtle)]" />
                <div className="flex-1 space-y-2">
                  <Skeleton className="h-4 w-24 rounded bg-[var(--color-bg-subtle)]" />
                  <Skeleton className="h-3 w-16 rounded bg-[var(--color-bg-subtle)]" />
                  <Skeleton className="h-5 w-12 rounded-full bg-[var(--color-bg-subtle)]" />
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </section>
    </div>
  );
};

export const AccountViewSkeleton = () => {
  return (
    <div className="p-6 space-y-8 animate-pulse">
      {/* Header Skeleton */}
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
        <div className="flex items-center gap-4">
          <Skeleton className="w-16 h-16 rounded-full bg-[var(--color-bg-subtle)]" />
          <div className="space-y-2">
            <Skeleton className="h-8 w-48 rounded-lg bg-[var(--color-bg-subtle)]" />
            <Skeleton className="h-4 w-32 rounded bg-[var(--color-bg-subtle)]" />
          </div>
        </div>
        <div className="flex gap-2">
          <Skeleton className="h-10 w-24 rounded-lg bg-[var(--color-bg-subtle)]" />
          <Skeleton className="h-10 w-24 rounded-lg bg-[var(--color-bg-subtle)]" />
        </div>
      </div>

      {/* Tabs Skeleton */}
      <div className="flex gap-1.5 p-1 bg-[var(--color-bg-secondary)] rounded-lg w-fit">
        {[1, 2, 3, 4].map((i) => (
          <Skeleton key={i} className="h-8 w-24 rounded-md bg-[var(--color-bg-subtle)]" />
        ))}
      </div>

      {/* Content Skeleton */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 space-y-6">
          <Card className="bg-[var(--color-bg-card)] border border-[var(--color-border-default)]">
            <CardContent className="p-6 space-y-4">
              <Skeleton className="h-6 w-32 rounded bg-[var(--color-bg-subtle)]" />
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {[1, 2, 3, 4].map((i) => (
                  <Skeleton key={i} className="h-12 w-full rounded-lg bg-[var(--color-bg-subtle)]" />
                ))}
              </div>
            </CardContent>
          </Card>
        </div>
        <div className="space-y-6">
          <Card className="bg-[var(--color-bg-card)] border border-[var(--color-border-default)]">
            <CardContent className="p-6 space-y-4">
              <Skeleton className="h-6 w-32 rounded bg-[var(--color-bg-subtle)]" />
              <div className="space-y-3">
                {[1, 2, 3].map((i) => (
                  <Skeleton key={i} className="h-16 w-full rounded-lg bg-[var(--color-bg-subtle)]" />
                ))}
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};
